module.exports = __webpack_public_path__ + "static/loading-2cb784e9b18771e431569e38359a4eda.gif";